module.exports = __webpack_public_path__ + "img/blood-test.11439f62.svg";